const comments = [
  {
    name: '追番少年阿杰',
    text: '6080影视真的太香了！画质超清晰而且完全不卡顿，追鬼灭之刃体验比某站好太多了，已经安利给所有漫友了！',
    time: '2小时前',
    tag: '老用户',
  },
  {
    name: '二次元小樱',
    text: '资源是真的全，连一些冷门老番都能找到。国漫区也做得很好，时光代理人高清版在这里追完的，强烈推荐！',
    time: '5小时前',
    tag: '活跃漫迷',
  },
  {
    name: '深夜补番人',
    text: '半夜追番速度起飞，一点缓冲都没有。界面很干净没有乱七八糟的广告弹窗，终于有个纯粹看动漫的地方了。',
    time: '8小时前',
    tag: '新用户',
  },
  {
    name: '热血漫死忠',
    text: '从海贼王到咒术回战，热血漫专区资源太丰富了。1080P画质拉满，打斗场面每一帧都看得清清楚楚。',
    time: '12小时前',
    tag: '活跃漫迷',
  },
  {
    name: '治愈系女孩',
    text: '最近在追迷宫饭，6080的更新速度真的快，日本才播完这边就有了。画质和翻译质量都很不错，已经离不开这个平台了！',
    time: '1天前',
    tag: '老用户',
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">漫迷热评</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">动漫迷们对6080影视的真实评价</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((c, i) => (
            <div key={i} className="rounded-xl bg-background-50 border border-background-200/70 p-4 md:p-5 flex flex-col gap-3">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-500 font-heading font-bold text-sm">{c.name.charAt(0)}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{c.name}</span>
                    <span className="px-1.5 py-0.5 bg-accent-100 text-accent-700 rounded text-xs font-medium">{c.tag}</span>
                  </div>
                  <span className="text-xs text-foreground-400">{c.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-400">
                {[...Array(5)].map((_, j) => (
                  <i key={j} className="ri-star-fill text-accent-400" style={{ width: '1em', height: '1em' }}></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}